export enum PusherChannel {
  MessageReceived = "message_received",
}
